












export default {
  name: 'SmileFaceIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
